import { memo } from 'react'
// Shares the AI-video version-history empty state's box (centered in both axes
// inside the HistoryContainer) so both version-history tabs read identically.
import * as Styled from 'containers/SubSidebar/AIVideoContent/HistoryTab/VersionHistoryEmpty/styled'
import { Text } from 'common-components'
import EmptyHistoryIcon from 'assets/svgr-icons/EmptyHistory.svg'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'

const VersionHistoryEmpty = () => {
  return (
    <Styled.EmptyState>
      <EmptyHistoryIcon />
      <Text type="h1" color="secondarySemiDark" align="center">
        {translate(T.NO_VERSION_HISTORY_LABEL)}
      </Text>
      <Text
        type="h2"
        color="secondary"
        align="center"
        fontWeight="400"
        lineHeight="1.3"
      >
        {translate(T.NO_IMAGE_RESULTS_FOUND_DESCRIPTION)}
      </Text>
    </Styled.EmptyState>
  )
}

export default memo(VersionHistoryEmpty)
